import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import '../common/font/font.css'
// 挂载一个自定义属性$http
Vue.prototype.$http = axios
// 全局配置axios请求根路径(axios.默认配置.请求根路径)
axios.defaults.baseURL = 'https://www.caidaqh.com'
import * as echarts from 'echarts' //引入echart
// import echarts from 'echarts'
Vue.prototype.$echarts=echarts;  //echarts 需要挂在到VUE原型上
Vue.prototype.$url='https://www.caidaqh.com'
import "./utils/china.js";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 必须在 element-ui CSS 之后导入，保证打包后这些 !important 规则
// 在生产 CSS 文件中位于 Element UI 默认规则之后，能稳定盖过默认值
import './css/drawer-overrides.css';
Vue.use(ElementUI);

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
Vue.prototype.imgUrl = e => {
  if (!e) {
    return ''
  } else if (e.substring(0, 4) != 'http') {
    return 'https://cdn.caidaqh.com' + e
  } else {
    return e
  }
}
Vue.prototype.filtersText = val => {
  if (val != null && val != "") {
    const rel = new RegExp("<.+?>","g");
    return val.replace(rel,'').trim();
  }
  return "";
}



// WEBPACK FOOTER //
// ./src/main.js